import * as _ from 'lodash';

export function isSearchQueryValid(query: string): boolean {
    return !_.isEmpty(prepareSearchQuery(query));
}

export function prepareSearchQuery(query: string): string {
    return _.trim(query);
}
